import { universalFetch } from 'core/fetch';
import { ANBIETER_API_PREFIX } from 'utils/enums';
import LocalGeoClient from './LocalGeoClient';

export default new LocalGeoClient({
  fetch: universalFetch,
  prefix: ANBIETER_API_PREFIX,
});
